export const PublicPages = [
  'login',
  'forgotpassword',
  'googlelogin',
  'resetpassword',
  'oauthshareconnect',
  'oauthsharesuccess',
  'oauthshareerror',
];

export const WelcomePathName = 'welcome';
